export const API_BASE_URL = (window as any).configs.REACT_APP_AUTH_API_BASE_URL;
export const CLIENTID = (window as any).configs.REACT_APP_CLIENTID;
export const IS_ENCRYPTION_ENABLED = (window as any).configs.REACT_IS_ENCRYPTION_ENABLED;
export const IS_MICROSOFT_ENABLED = (window as any).configs.REACT_IS_MICROSOFT_ENABLED;